//!#system	

<template>
	<div>
		<v-card :color="headerColor" dark shaped>
			<div v-if="value.avatar && value.avatar.uniqueFileName" style="float: right;margin-top: -10px;margin-right: -22px;">
				<application-file-view 
					:applicationFile="value.avatar"
					:avatar="true"
				/>
			</div>
			<v-card-title class="title">
				<v-avatar :left="true" color="blue lighten-1">{{value.initials}}</v-avatar>
				&nbsp;
				{{value.name}}
				&nbsp;
				<v-chip title="User-Type">{{value.userType.type}}</v-chip>
			</v-card-title>
		</v-card>
		<v-layout wrap>
			<v-flex xs12 sm6 md6 lg6 sm12>
				<div class="data-spacing">
					<div class="overline" style="font-family: 'Poppins' !important;">Username</div>
					{{value.username}}
				</div>
			</v-flex>
			<v-flex xs12 sm6 md6 lg6 sm12>
				<div class="data-spacing">
					<div class="overline" style="font-family: 'Poppins' !important;">Email</div>
					{{value.emailAddress}}
				</div>
			</v-flex>
			<v-flex xs12 sm12 md12 lg12>
				<div class="data-spacing">
					<div class="overline" style="font-family: 'Poppins' !important;">Groups</div>
					<div>
						<v-chip class="mr-2" v-for="group in value.groups" :key="group.name" color="secondary">{{group.name}}</v-chip>
					</div>
				</div>
			</v-flex>
			<v-flex xs12 sm12 md12 lg12>
				<div class="data-spacing">
					<div class="overline" style="font-family: 'Poppins' !important;">Status</div>
				</div>
			</v-flex>
			<v-flex xs12 sm6 md6 lg6 sm12>
				<div class="data-spacing">
					<span v-if="value.activated">
						<v-icon color="green">mdi-account-check</v-icon>
						User is active.
					</span>
					<span v-else>
						<v-icon color="gray">mdi-close-thick</v-icon>
						User is not active.
					</span>
				</div>
			</v-flex>
			<v-flex xs12 sm6 md6 lg6 sm12>
				<div class="data-spacing">
					<span v-if="value.dashboardAccess">
						<v-icon color="blue">mdi-check-outline</v-icon>
						User has access to the app.
					</span>
					<span v-else>
						<v-icon color="gray">mdi-close-thick</v-icon>
						No access to the app.
					</span>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import ApplicationFileView from '@/components/pieces/ApplicationFileView';
export default {
	name: 'UserDetailView',
	components: {
		ApplicationFileView
	},
	props: {
		routeInfo: {
			type: Object
		},
		value: {
			type: Object
		},
		isBase: {
			type: Boolean,
			default: true
		},
		headerColor: {
			type: String,
			default: 'primary'
		}
	}
}
</script>

<style>
.data-spacing {
	margin-bottom: 15px;
	margin-top: 5px;
	margin-left: 10px;
}
</style>